<template>
  <div>
    <PageAllow controller="SummaryMonthlyStatement" action="view"/>
    <Breadcrumbs :items="items" />

    <!-- 月结账单信息 -->
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panelsA" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{  $t("CRUD.info", [$t("summaryMonthlyStatementDetail.ObjectName")]) }}
<!--              <v-chip-->
<!--                small-->
<!--                label-->
<!--                class="ms-4 mt-1"-->
<!--                :color="summary_monthly_statement.status | returnBasketStatusColor"-->
<!--                :text-color="summary_monthly_statement.status | returnBasketStatusTextColor"-->
<!--              >-->
<!--                {{ summary_monthly_statement.status | returnBasketStatusText }}-->
<!--              </v-chip>-->
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
              </v-sheet>
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 客户名称 / 客户编号 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.shop", [$consts.shopName()])}}{{ $t("Global.colon") }}
                  </span>
                  {{ summary_monthly_statement.shop_name + " / " + summary_monthly_statement.shop_code }}
                </v-card>
              </v-col>
              <!-- 起始时间-结束时间 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.summary_date")}}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ summary_monthly_statement.summary_start_date | formatDate }} - {{ summary_monthly_statement.summary_end_date | formatDate }}
                  </span>
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.created")}}{{ $t("Global.colon") }}
                  </span>
                  {{ summary_monthly_statement.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 结算金额 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.summary_fee")}}{{ $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                     {{ $t("Global.money") }}{{ (summary_monthly_statement.need_receivable - summary_monthly_statement.need_payment) | formatMoney }}
                  </span>
                </v-card>
              </v-col>
              <!-- 总应收 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.need_receivable")}}{{ $t("Global.colon") }}
                  </span>
                  {{ $t("Global.money") }}{{ (summary_monthly_statement.need_receivable) | formatMoney }}
                </v-card>
              </v-col>
              <!-- 总应付 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.need_payment")}}{{ $t("Global.colon") }}
                  </span>
                  {{ $t("Global.money") }}{{ (summary_monthly_statement.need_payment) | formatMoney }}
                </v-card>
              </v-col>
              <!-- 总实收 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.actual_receivable")}}{{ $t("Global.colon") }}
                  </span>
                  {{ $t("Global.money") }}{{ (summary_monthly_statement.actual_receivable) | formatMoney }}
                </v-card>
              </v-col>
              <!-- 总实付 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.actual_payment")}}{{ $t("Global.colon") }}
                  </span>
                  {{ $t("Global.money") }}{{ (summary_monthly_statement.actual_payment) | formatMoney }}
                </v-card>
              </v-col>
              <!-- 总运费 -->
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.order_logistics_fee")}}{{ $t("Global.colon") }}
                  </span>
                  {{ $t("Global.money") }}{{ (summary_monthly_statement.order_logistics_fee) | formatMoney }}
                </v-card>
              </v-col>
              <!-- 总服务费 -->
              <v-col cols="12" md="6" v-if="settings && settings.service_charge_enable">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("summaryMonthlyStatementDetail.Fields.order_service_charge")}}{{ $t("Global.colon") }}
                  </span>
                  {{ $t("Global.money") }}{{ (summary_monthly_statement.order_service_charge) | formatMoney }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <!-- 对账详情 -->
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-card>
        <v-expansion-panels v-model="panelsB" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("summaryMonthlyStatementDetail.DetailFields.title") }}
                <v-spacer />
                <v-sheet class="pt-1 transparent-background-color d-inline-block">
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <!-- 对账详情 -->
              <v-data-table
                :headers="DetailHeaders"
                :items="summary_monthly_statement_details"
                hide-default-footer
                disable-pagination
                class="pb-2"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.object="{ item }">
                  {{ item.stock ? item.stock.name : $t("summaryMonthlyStatementDetail.refund") }}
                </template>
                <template v-slot:item.finally_sale_total_fee="{ item }">
                  {{ $t("Global.money") }}{{ item.finally_sale_total_fee | formatMoney }}
                </template>
                <template v-slot:item.finally_return_total_fee="{ item }">
                  {{ $t("Global.money") }}{{ item.finally_return_total_fee | formatMoney }}
                </template>
                <template v-slot:item.summary_fee="{ item }">
                  <span class="red--text">
                    {{ $t("Global.money") }}{{ (item.finally_sale_total_fee - item.finally_return_total_fee) | formatMoney }}
                  </span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    v-if="$permission.permissionAllow('SummaryMonthlyStatement', 'dailyStatement')"
                    small
                    dark
                    color="info"
                    class="px-2 me-2 mb-1"
                    @click.stop="routerDaily(item)"
                  >
                    {{ $t("summaryMonthlyStatementDetail.actions.detail") }}
                  </v-btn>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SummaryMonthlyStatement from "@/api/summary_monthly_statement";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.statementManagement"),
        disabled: false,
        href: "/summary-monthly-statement",
      },
      {
        text: i18n.t("Nav.summaryMonthlyStatement"),
        disabled: false,
        href: "/summary-monthly-statement",
      },
      {
        text: i18n.t("summaryMonthlyStatementDetail.title"),
        disabled: true,
        href: "/summary-monthly-statement",
      },
    ],
    DetailHeaders() {
      let headers = [
        {
          text: i18n.t("summaryMonthlyStatementDetail.DetailFields.object"),
          align: "center",
          sortable: false,
          value: "object",
        },
        {
          text: i18n.t("summaryMonthlyStatementDetail.DetailFields.finally_sale_total_fee"),
          align: "end",
          sortable: false,
          value: "finally_sale_total_fee",
        },
        {
          text: i18n.t("summaryMonthlyStatementDetail.DetailFields.finally_return_total_fee"),
          align: "end",
          sortable: false,
          value: "finally_return_total_fee",
        },
        {
          text: i18n.t("summaryMonthlyStatementDetail.DetailFields.summary_fee"),
          align: "end",
          sortable: false,
          value: "summary_fee",
        },
        {
          text: i18n.t("summaryMonthlyStatementDetail.DetailFields.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        }
      ];
      return headers;
    },
    ...mapState(["settings", "loading"]),
  },

  data: () => ({
    panelsA: [0],
    panelsB: [0],
    summary_monthly_statement: [],
    summary_monthly_statement_details: [],
  }),

  mounted() {
    this.getReturnBasketsDetailsFromAPI()
  },

  methods: {
    getReturnBasketsDetailsFromAPI() {
      SummaryMonthlyStatement.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.summary_monthly_statement = response.data.summary_monthly_statement;
            this.summary_monthly_statement_details = this.summary_monthly_statement.summary_monthly_statement_details;
          }
        }.bind(this)
      );
    },
    routerDaily(data) {
      let options = {
        summary_time_from: this.$datetimeUtils.formatTime(this.summary_monthly_statement.summary_start_date),
        summary_time_to: this.$datetimeUtils.formatTime(this.summary_monthly_statement.summary_end_date),
        shop_id: this.summary_monthly_statement.shop_id,
        stock_ids: [data.stock_id]
      }
      sessionStorage.setItem(
          "summary-daily-statement-options",
          JSON.stringify(options)
      );
      sessionStorage.setItem(
          "summary-daily-statement-searchers",
          JSON.stringify({
            shop_id: options.shop_id,
            stock_id: data.stock_id
          })
      );
      this.$router.push("/summary-daily-statement");
    }
  },

  watch: {},
};
</script>